"use client";

import { useEffect, useState } from "react";

import ShareIcon from "@repo/ui-system/icons/social/share/outline.svg";
import clsx from "clsx";

type Props = {
  shareData: ShareData | null;
};

export function ShareButton({ shareData }: Props) {
  const [canShare, setCanShare] = useState(false);

  useEffect(() => {
    if (shareData && navigator.canShare && navigator.canShare(shareData)) {
      console.log("[share button] can share");
      setCanShare(true);
    } else {
      console.log("[share button] cannot share");
      setCanShare(false);
    }
  }, [shareData]);

  const handleShare = async () => {
    if (!shareData) {
      console.error("[share button] no share data");
      return;
    }
    try {
      await navigator.share(shareData);
    } catch (error) {
      console.error("[share button] error sharing:", error);
    }
  };

  return (
    <button
      type="button"
      aria-label="Share"
      className={clsx(
        "p-2 rounded-full border border-[#C1C5D3] transition-all duration-200",
        "lg:hover:not-disabled:border-[#A3A9BE] focus:not-disabled:border-[#A3A9BE]", // hover
        "disabled:opacity-50", // disabled
      )}
      onClick={handleShare}
      disabled={!canShare}
    >
      <ShareIcon className="size-4" />
    </button>
  );
}
